import AddonDefaultSizeSelector from './AddonDefaultSizeSelector'
import AddonLacesSizeSelector from './AddonLacesSizeSelector'
import AddonInsoleSizeSelector from './AddonInsoleSizeSelector'

const socksSizeDescriptionMap = {
  XS: '(US W 5-7 / M 3.5 - 5.5)',
  S: '(US W 7.5 - 9 / M 6 - 7.5)',
  M: '(US W 9.5 - 12 / M 8 - 10.5)',
  L: '(US W 12.5 - 14.5 / M 11 - 13)'
}

const skateStyles = ['berrics', 'catiba-pro', 'catiba-pro-high', 'naioca', 'vallely', 'slip-on-skate']

const addonCallbacks = {
  sizeSelector(type) {
    switch (type) {
      case 'laces':
        return AddonLacesSizeSelector
      case 'insole':
        return AddonInsoleSizeSelector
      case 'shoebag':
        return AddonLacesSizeSelector
    }

    return AddonDefaultSizeSelector
  },
  cartProperties(type, { selectedProduct, selectedVariant }) {
    let size = selectedVariant?.node.selectedOptions[2].value

    if (type === 'insole') {
      let fake_gender = '' // gender of current product page
      let real_gender = '' // gender from which the real shoe size will be returned
      let fake_size = 0 // set fake size based on whether object returned is variant or custom
      let real_size = 0 // fake size +/- 1.5

      if (selectedVariant?.node.selectedOptions[0].value === 'Women') {
        // Women Size Selection
        fake_gender = 'men'
        real_gender = 'women'
        real_size= parseFloat(selectedVariant?.node.selectedOptions[2].value)
        fake_size = (parseFloat(real_size) - 1.5)
      } else {
        // Men Size Selection
        fake_gender = 'women'
        real_gender = 'men'
        real_size=parseFloat(selectedVariant?.node.selectedOptions[2].value)
        fake_size = (parseFloat(real_size) + 1.5)
      }

      size = real_gender + ' ' + real_size + ' / ' + fake_gender + ' ' + fake_size
    } else if (type === 'shoebag') {
      size = ''
    }

    let options = {
      size
    }

    if (type !== 'laces' && type !== 'insole' && type !== 'shoebag') {
      options = {
        ...options,
        _tags: selectedProduct.node.tags,
        ...(selectedVariant.node.currentlyNotInStock ? {
          PREORDER: 'PREORDER',
          preorderestimate: selectedProduct.node.preorder?.value || ''
        }: {})
      }
    }

    if (type === 'gwp') {
      const existingItem = window.CartJS?.cart.items.find(item => item.discounts.some(discount => discount.title === window.gwpSettings?.discountTitle))

      if (existingItem) {
        options = {
          ...existingItem.properties,
          ...options
        }
      }
    }

    return options
  },
  postAddToCart(type, { mainProductId, variantId }) {
    if (type === 'laces') {
      const variantWithLace = JSON.parse(localStorage.getItem('variantWithLace')) || []
      variantWithLace.push(mainProductId)
      localStorage.setItem('variantWithLace', JSON.stringify(variantWithLace))
      localStorage.setItem('variantAccessoriesID', JSON.stringify(variantId))
    } else if (type === 'insole') {
      const variantWithInsole = JSON.parse(localStorage.getItem('variantWithInsole')) || []
      variantWithInsole.push(mainProductId)
      localStorage.setItem('variantWithInsole', JSON.stringify(variantWithInsole))
      localStorage.setItem('variantAccessoriesID', JSON.stringify(variantId))
    } else if (type === 'gwp') {
      const existingItem = window.CartJS?.cart.items.find(item => `${item.id}` === `${mainProductId}`)

      if (existingItem) {
        window.fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: {
              [existingItem.id]: 0
            }
          })
        })
        .then(() => {
          CartJS.getCart()
        })
      }
    } else if (type === 'shoebag') {
      const variantWithShoeBag = JSON.parse(localStorage.getItem('variantWithShoeBag')) || []
      variantWithShoeBag.push(mainProductId)
      localStorage.setItem('variantWithShoeBag', JSON.stringify(variantWithShoeBag))
      localStorage.setItem('variantAccessoriesID', JSON.stringify(variantId))
    }
  },
  addonTitle(type) {
    if (type === 'laces') {
      return 'Extra Laces'
    }

    if (type === 'insole') {
      return 'Extra Insole'
    }

    if (type === 'shoebag') {
      return 'Travel Shoe Bag'
    }

    return ''
  },
  sizeDescription(type, label) {
    if (type === 'socks') {
      if (label in socksSizeDescriptionMap) {
        return socksSizeDescriptionMap[label]
      }
    }

    return ''
  },
  reorderIdentifiers(type, { identifiers, originalIdentifiers }) {
    if (type === 'socks') {
      const skateIndex = identifiers.findIndex(item => item.key.includes('skate'))

      if (skateIndex >= 0) {
        const hasSkateItem = (window.CartJS?.cart?.items ?? []).some(item => {
          return skateStyles.some(style => item.handle.includes(style))
        })

        if (hasSkateItem) {
          const newIdentifiers = [...identifiers]
          newIdentifiers.splice(skateIndex, 1)

          return [
            identifiers[skateIndex],
            ...newIdentifiers
          ]
        } else {
          return [...originalIdentifiers]
        }
      }
    }

    return identifiers
  }
}

const addonCallback = (event, type, data) => {
  if (typeof addonCallbacks[event] === 'function') {
    return addonCallbacks[event](type, data)
  }

  return null
}

export default addonCallback